@if (ready) {
  <div>
    <div>
      @switch (phenodataState) {
        @case (PhenodataState.OWN_PHENODATA) {
          <div>
            <div class="phenodata-button-group mb-2">
              <button class="btn btn-sm btn-success me-1" (click)="openAddColumnModal()">
                <i class="fas fa-plus"></i>
                Add column
              </button>
              <button class="btn btn-sm btn-secondary float-end" (click)="reset()" [disabled]="!canReset">Reset</button>
            </div>

            @if (groupColumnMissing) {
              <div class="alert alert-info p-0 mb-2">
                <i class="fas fa-fw fa-exclamation-circle me-1"></i>
                <span class="font-italic">Group column is missing</span>
              </div>
            }
            @if (!phenodataFilled && !groupColumnMissing) {
              <div class="alert alert-warning p-0 mb-2">
                <i class="fas fa-fw fa-exclamation-circle me-1"></i>
                <span class="font-italic">Group column contains empty values</span>
              </div>
            }
          </div>
        }

        @case (PhenodataState.INHERITED_PHENODATA) {
          <div>
            Using phenodata of
            <i>{{ phenodataAncestor.name }}</i>
          </div>
        }

        @case (PhenodataState.NO_PHENODATA) {
          <div>
            <i>No phenodata available</i>
          </div>
        }

        @case (PhenodataState.DATASET_NULL) {
          <div></div>
        }
      }
    </div>
  </div>
}

<!-- tableContainer must always be around or new Handsontable fails, so no ngIf for it -->
<div class="scrolling-wrapper" #horizontalScroll>
  <div id="tableContainer"></div>
</div>
